<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="error-template">
            <img src="@/assets/logo.png" class="img-fluid" alt />
            <br />
            <br />
            <br />
            <br />
            <!-- <h2>404 Not Found</h2> -->
            <div class="error-details">{{ $t('p404')}}</div>
            <div class="error-actions">
              <a href="#" @click="back()" class="btn btn-brand btn-lg">
                <span class="glyphicon glyphicon-home"></span>
                {{ $t('go_back')}}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
body {
}
.error-template {
  padding: 40px 15px;
  text-align: center;
}
.error-actions {
  margin-top: 15px;
  margin-bottom: 15px;
}
.error-actions .btn {
  margin-right: 10px;
}
</style>
<script>
export default {
  methods: {
    back() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>